import {Component, Input, OnInit, Output, EventEmitter, HostListener, KeyValueDiffers, DoCheck} from '@angular/core';
import {Data, Options} from './ihsm-dropdown-lib.interface';

@Component({
  selector: 'app-ihsm-dropdown-lib',
  templateUrl: './ihsm-dropdown-lib.component.html',
  styleUrls: ['./ihsm-dropdown-lib.component.scss']
})
export class IhsmDropdownLibComponent implements OnInit, DoCheck {
  toggle = false;
  selectedItem: Options | null | undefined;
  selectedItemMulti: Options[] = [];
  selectedItemMultiReadOnly = '';
  showDropdown = false;
  restoreSelectedItemMulti: Options[] = [];
  private wasClickInside = false;
  label = '';
  private previousValue: Options[] = [];
  disableApplyButton = true;
  searchValue = '';
  showList = false;
  dataCopy?: Data;
  differ: any;

  @Input() data?: Data;
  @Input() disabled = false;
  @Input() hasFilter = false;
  @Input() maxLabelsDisplay = 10;
  @Input() maxItemsToChoose = -1;
  @Input() dropdownType = 'single';
  @Input() enableSearch = false;
  @Output() itemSelectedEvent = new EventEmitter<any>();
  @Output() filterAppliedEvent = new EventEmitter<any>();
  @Output() itemsDisabled = new EventEmitter<boolean>();

  @HostListener('click')
  clickInsideComponent(): void {
    this.wasClickInside = true;
  }

  @HostListener('document:click')
  clickOutsideComponent(): void {
    if (!this.wasClickInside && this.toggle) {
      this.toggle = false;
      this.searchValueChange('');
      this.copyData();
      this.restoreState();
    }
    this.wasClickInside = false;
    this.searchValue = '';
  }

  constructor(private differs: KeyValueDiffers) {
    this.differ = this.differs.find({}).create();
  }

  ngOnInit(): void {
    const selectedOption = this.data && this.data.options ? this.data.options.filter(option => option.selected)[0] : null;
    if (this.dropdownType === 'single') {
      this.selectItem(selectedOption);
    }
    this.copyData();
    if (this.data && this.data.options) {
      this.createReadOnlyLabel(null);
    }
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.data?.options);
    if (change){
      this.previousValue = JSON.parse(JSON.stringify(this.data?.options.filter((opt: any) => opt.selected)));

      if (this.data && this.data.options) {
        // this.selectedItemMulti = [];
        if (this.data.options.filter(p => p.selected).length > 0) {
          this.data.options.forEach(option => {
            if (option.selected) {
              if (!this.checkSelectedItemMulti(option)) {
                this.selectedItemMulti.push(option);
              }
            }
          });
        }
        this.selectedItem = this.data.options.find(p => p.selected);
        if (this.dropdownType === 'single') {
          this.label = this.selectedItem && this.selectedItem.label ? this.selectedItem.label.toString() : 'Select Item';
        }
        if (this.dropdownType === 'multi') {
          this.createReadOnlyLabel(null);
          this.itemSelectedEvent.emit(this.selectedItemMulti);
        }
      }
    }
  }

  toggleDropdown(): void {
    this.disableApplyButton = !this.unequalObjects();
    this.toggle = !this.toggle;
    if (this.toggle) {
      this.createRestorePoint();
    }
    if (this.dropdownType === 'multi'){
      if (this.toggle){
        this.copyData();
      }else {
        this.restoreData();
      }
    }else{
      if (this.toggle){
        this.copyData();
      }
    }
    setTimeout(() => {
      this.toggleDisableItems();
    }, 10);
  }

  createRestorePoint(): void {
    this.restoreSelectedItemMulti = JSON.parse(JSON.stringify(this.selectedItemMulti, this.getCircularReplacer()));
  }

  getCircularReplacer(): any{
    const seen = new WeakSet();
    return (key: any, value: any) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  }

  restoreState(): void {
    if (this.dropdownType === 'multi') {
      this.restoreData();
      if (this.selectedItemMulti.length > 0) {
        this.selectedItemMulti.forEach(option => {
          option.selected = false;
        });
      }
      this.selectedItemMulti = [];
      // if (this.data && this.data.options) {
      //   this.data.options.forEach(option => {
      //     if (this.restoreSelectedItemMulti.filter(p => p.label === option.label).length > 0) {
      //       option.selected = true;
      //       this.selectedItemMulti.push(option);
      //     }
      //   });
      // }
      this.createReadOnlyLabel(null);
    }
  }

  selectItem(option: Options | null): void {
    this.selectedItem = option;
    this.showDropdown = true;
    if (this.data && this.data.options && option) {
      this.data.options.forEach(opt => {
        opt.selected = false;
      });
      option.selected = true;
      this.filterAppliedEvent.emit(option);
    }
  }

  selectItemMulti(e: any, option: Options): void {
    const itemPresent = this.selectedItemMulti.findIndex(item => option.label === item.label);
    if (itemPresent > -1) {
      option.selected = false; // when deselecting selected should go to false
      this.selectedItemMulti.splice(itemPresent, 1);
    } else {
      this.selectedItemMulti.push(option);
      option.selected = true;
      if (this.data && this.data.options && this.selectedItemMulti.length === this.data.options.length && this.data.customAllOption) {
        this.toggleDeselectAllOptions(e);
      }
    }
    this.disableApplyButton = !this.unequalObjects();
    this.createReadOnlyLabel(e);
    setTimeout(() => {
      this.toggleDisableItems();
    }, 10);
  }

  toggleDisableItems(): void{
    const elm = document.getElementsByClassName('ihsm-multi-links');
    const count = this.selectedItemMulti.filter((option: any) => option.selected) ?
      this.selectedItemMulti.filter((option: any) => option.selected).length : 0;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elm.length; i++){
      if (count < this.maxItemsToChoose){
        elm[i].classList.remove('disable-option');
        this.itemsDisabled.emit(false);
      }else{
        if (elm[i].getElementsByClassName('ihsm-multi-option-selected').length === 0){
          elm[i].classList.add('disable-option');
          this.itemsDisabled.emit(true);
        }
      }
    }
  }

  checkSelectedItemMulti(option: Options): boolean {
    if (this.selectedItemMulti) {
      const itemPresent = this.selectedItemMulti.filter(item => option.value === item.value);
      return itemPresent.length > 0;
    } else {
      return false;
    }
  }

  toggleSelectAllOptions(e: any): void {
    if (this.selectedItemMulti.length) {
      this.selectedItemMulti = [];
    } else {
      // @ts-ignore
      this.selectedItemMulti = this.data.options.slice(0);
      this.selectedItemMulti.forEach(item => {
        item.selected = true;
      });
    }
    this.disableApplyButton = !this.unequalObjects();
    this.createReadOnlyLabel(e);
  }

  toggleDeselectAllOptions(e: any): void {
    if (this.selectedItemMulti.length > 0) {
      this.selectedItemMulti.forEach(option => {
        option.selected = false;
      });
      this.selectedItemMulti = [];
    }
    if (this.data && this.data.options) {
      this.data.options.forEach(option => {
        option.selected = false;
      });
    }
    this.disableApplyButton = !this.unequalObjects();
    this.createReadOnlyLabel(e);
  }

  createReadOnlyLabel(e: any): void {
    if (this.data) {
      const selectedItemMultiReadOnly = this.selectedItemMulti.map(item => item.label);
      if (selectedItemMultiReadOnly.length === 0) {
        this.selectedItemMultiReadOnly = 'Select Item';
      } else {
        this.selectedItemMultiReadOnly = selectedItemMultiReadOnly.length >= this.maxLabelsDisplay ? selectedItemMultiReadOnly.length + ' selected.'
          : selectedItemMultiReadOnly.join(', ');
      }
    }

    if (e) {
      e.stopPropagation();
    }
  }

  submitSelectedOptions(): void {
    this.previousValue = JSON.parse(JSON.stringify(this.selectedItemMulti, this.getCircularReplacer()));
    this.restoreData();
    this.filterAppliedEvent.emit(this.selectedItemMulti);
  }

  unequalObjects(): boolean {
    return this.selectedItemMulti.length < this.previousValue.length ? true : this.selectedItemMulti.some((item: Options) =>
      this.previousValue.findIndex((value: Options) => value.label === item.label && value.selected === item.selected) === -1);
  }

  formatNumber(input: string | number): string {
    input = typeof input === 'number' ? input.toString() : input;
    return input.replace(/(.)(?=(.{3})+$)/g, '$1,');
  }

  searchValueChange(e: any): any {
    // @ts-ignore
    this.data?.options = this.dataCopy?.options.filter((option: any) => option.label.toUpperCase().includes(e.toUpperCase()));
    setTimeout(() => {
      this.toggleDisableItems();
    }, 10);
  }

  searchContainerSelected(e: any): void {
    e.stopPropagation();
  }

  copyData(): void {
    this.dataCopy = JSON.parse(JSON.stringify(this.data, this.getCircularReplacer()));
  }

  restoreData(): void {
    this.data = this.dataCopy;
    this.data?.options.forEach((option: any) => {
      option.selected = this.selectedItemMulti.find((item: any) => item.label === option.label) !== undefined;
    });
  }
}
